import React from 'react';

import PropTypes from 'prop-types';
import clsx from 'clsx';

const NavigationButton = (props) => {
  const { id, className, navigate, onClick, disabled, type } = props.button;
  return (
    <button
      id={id}
      className={clsx(`navigationButton`, {
        [className]: className,
        [type]: type,
      })}
      disabled={disabled}
      onClick={onClick}
    >
      {navigate}
    </button>
  );
};

export default NavigationButton;

NavigationButton.propTypes = {
  button: PropTypes.shape({
    navigate: PropTypes.string,
    disabled: PropTypes.bool,
  }).isRequired,
};
